/* global Image */
import React from "react";
import Waypoint from "react-waypoint";
import { css } from "aphrodite/no-important";

import style from "./style";

class Media extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bgImage: null,
      videoSrc: null,
    };
  }

  onEnter = () => {
    if (!this.state.bgImage) {
      const tempImage = new Image();
      tempImage.src = this.props.src;

      tempImage.onload = () => {
        tempImage.remove();

        this.setState((state, props) => {
          if (this.props.type === "video") {
            return {
              bgImage: props.src,
              vidSrc: props.vidSrc,
            };
          }

          return { bgImage: props.src };
        });
      };
    }
  };

  render() {
    const { type, paddingTop, customStyles, noMargin } = this.props;

    const { bgImage, vidSrc } = this.state;

    const mediaStyles = css(style.media, bgImage && style.animate);

    const mediaContainerStyles = css(
      style.mediaContainer,
      customStyles && customStyles,
      noMargin && style.no_margin
    );

    return (
      <Waypoint onEnter={this.onEnter}>
        <div className={mediaContainerStyles} style={{ paddingTop }}>
          {type === "video" ? (
            <video
              src={vidSrc}
              poster={bgImage}
              autoPlay
              loop
              className={`${mediaStyles} media`}
              muted
              width="100%"
            />
          ) : (
            <div
              className={`${mediaStyles} media`}
              style={{ backgroundImage: `url(${bgImage})` }}
            />
          )}
        </div>
      </Waypoint>
    );
  }
}

Media.defaultProps = {
  customStyles: null,
  paddingTop: null,
  noMargin: false,
};

Media.propTypes = {
  type: React.PropTypes.string.isRequired,
  paddingTop: React.PropTypes.string,
  src: React.PropTypes.string.isRequired,
  customStyles: React.PropTypes.shape({
    _name: React.PropTypes.string.isRequired,
  }),
  noMargin: React.PropTypes.bool,
};

export default Media;



// WEBPACK FOOTER //
// ./src/components/Media/index.js